import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { useFormik } from "formik";
import toast from "react-hot-toast";

import "../Asociados/createAsociados.css";
import "./createOrden.css";
import {
  configForaneoFormValidation,
  createOrdenFormValidation,
} from "../../../../helper/validate";

import * as api from "helper/helper";
import "./../formsCommons.css";
// CHECAR import useSearchList, { useFormInput } from "../../../../hooks/custom.hooks";
//import stylesPro from "./createOrden.module.css";
//import menuStyle from "../../../../styles/Menu.module.css";

import { EstadoBodega } from "../../../../helper/const";
import { buildNameWithId, Singleton } from "helper/tools";
import invalidClass, { formikExtra } from "../../helperFunctions/helpers";
import LoadingButton from "../LoadingButton/LoadingButton";
import CreateClient from "../Clientes/CreateClient";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import { useTimeout } from "../../hooks/useTimeout";
import { format } from "date-fns";
//import TableOptionCheck, { FilterType } from "../Productos/TableOptionCheck";

const ConfigForaneo = forwardRef(({ item, reloadOrdenes }, ref) => {
  const modalRef = useRef();
  const buttonCancelModalRef = useRef();

  /// CHECAR  useTraceUpdate(props, "CreateOrdenVenta");
  const [isActiveDisabled, setIsActiveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const createMode =
    item == null || (item && Object.keys(item).length === 0) || item.id === 0;

  useEffect(() => {
    console.log("---> change item: " + item);
    let isActiveDisable = createMode;
    setIsActiveDisabled(isActiveDisable);

    if (item == null) {
      return;
    }

    formik?.resetForm();

    loadItem(item);
  }, [item]);

  const fetchData = async () => {};

  useEffect(() => {
    formik?.resetForm();

    fetchData();

    const newPermissions = PermissionsForSection(Sections.Clientes);
    setPermissions(newPermissions);
  }, []);

  let initialValues = {
    id: 0,
    ordenVentaId: "",
    paqueteria: "",
    guia: "",
    fechaEntrega: "",
  };

  //tagRef.current?.removeAll();
  if (!createMode) {
    const fechaEntregaDate = format(item.fechaEntrega, "yyyy-MM-dd");

    initialValues = item;
    initialValues.fechaEntrega = fechaEntregaDate;
  }

  //console.log("-->");
  //console.log(initialValues);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: configForaneoFormValidation,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { props, setSubmitting }) => {
      //  values.tags = tagRef.current.getTags().values.join(",");
      //is - invalid;
      //console.log(tags);

      /*
       "id": 0,
      "ordenVentaId": 0,
      "paqueteria": "string",
      "guia": "string",
      "fechaEntrega": "2025-06-02T23:51:14.298Z"
      */

      values.ordenVentaId = item.ordenVentaId;

      // normalize
      /*    const ordenVentaDetalles = productosAgregados.map((item) => {
        return {
          productoId: item.id,
          cantidad: item.cantidad,
          precio: item.precio,
          total: item.total,
        };
      });

      values.totalVenta = ordenTotal;
      values.subTotalVenta = ordenSubtotal;

      values.ordenVentaDetalles = ordenVentaDetalles;
*/
      /* default es En proceso Id = 1
      apartado = 2
      */
      /*    const estadoBodegaId = formik.values.apartado
        ? EstadoBodega.Apartado
        : EstadoBodega.EnProceso;
      values.estadoBodegaId = estadoBodegaId;*/

      /*if (values.id === 0) {
        const toastId = toast.loading("Creando Orden de Venta...");
        let response = await api.updateOrdenVentaEntregaForanea(values).catch((e) => {
          toast.dismiss(toastId);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al Orden de Venta. ${e.mensaje}`);
            setIsLoading(false);
            return;
          }
          toast.error("Error al Orden de Venta.");
          setIsLoading(false);
        });

        setIsLoading(false);
        toast.dismiss(toastId);

        if (!response) return;

        toast.success("Orden de Venta creado.");
        reloadOrdenes();

        buttonCancelModalRef.current.click();
      } else {*/
      const toastId = toast.loading("Actualizando Orden...");
      setIsLoading(true);
      const response = await api
        .updateOrdenVentaEntregaForanea(values.ordenVentaId, values)
        .catch((e) => {
          setIsLoading(false);
          toast.dismiss(toastId);
          toast.error("Error al actualizar Orden.");
        });
      if (!response) return;

      /*const responseActivo = await api
          .activarUsuario(values.id, values.activo)
          .catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            toast.error("Error al actualizar activo Producto.");
          });
*/
      toast.dismiss(toastId);
      setIsLoading(false);

      //  if (!responseActivo) return;

      toast.success("Orden actualizado.");
      reloadOrdenes && reloadOrdenes();

      buttonCancelModalRef.current.click();
      //}
    },
  });

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return formik.values;
    },
    toggleModal: () => {
      formik?.resetForm();
      modalRef.current.click();
    },
  }));

  const handleStatusClick = (event, item, options) => {};

  const handleOnChange = (value) => {
    console.log("-->");
  };

  function loadItem(newItem) {
    const isEmpty = newItem && Object.keys(newItem).length === 0;
    if (isEmpty) {
      return;
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <>
      <button
        ref={modalRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropConfigForaneo"
        hidden
      >
        Abrir Crear Orden
      </button>

      <div
        className="modal fade modal-lg"
        id="staticBackdropConfigForaneo"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropConfigForaneoLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Configurar Foraneo
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <form className="row g-3" onSubmit={handleSubmit}>
                <div className="form-control">
                  <h5>Información General</h5>

                  <div className="col align-self-start">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      Paqueteria
                    </label>
                    <input
                      type="text"
                      className={`form-control ${invalidClass(
                        formik.errors.paqueteria,
                      )}`}
                      id="validationName"
                      aria-describedby="emailHelp"
                      {...formik.getFieldProps("paqueteria")}
                      {...formikExtra.upperCase("paqueteria", formik)}
                    />
                    <div className="valid-feedback">Looks good!</div>
                    <div className="invalid-feedback">
                      {formik.errors.paqueteria}
                    </div>
                  </div>

                  <div className="row align-items-center">
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Guia
                      </label>
                      <input
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.guia,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        {...formik.getFieldProps("guia")}
                        {...formikExtra.upperCase("guia", formik)}
                      />
                      <div className="valid-feedback">Looks good!</div>
                      <div className="invalid-feedback">
                        {formik.errors.guia}
                      </div>
                    </div>
                  </div>

                  <div className="row align-items-center">
                    <div className="col align-self-start">
                      <label htmlFor="validationDOB" className="form-label">
                        Fecha de Entrega
                      </label>
                      <input
                        type="date"
                        min="1900-01-01"
                        className={`form-control ${invalidClass(
                          formik.errors.fechaEntrega,
                        )}`}
                        id="validationDOB"
                        aria-describedby="emailHelperwerwer"
                        placeholder="YYYY-MM-DD"
                        {...formik.getFieldProps("fechaEntrega")}
                        onChange={(e) => {
                          formik.setFieldValue("fechaEntrega", e.target.value);
                        }}
                      />
                      <div className="valid-feedback">Looks good!</div>
                      <div className="invalid-feedback">
                        {formik.errors.fechaEntrega}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={buttonCancelModalRef}
                  >
                    Cancelar
                  </button>
                  {
                    <LoadingButton
                      style={{ height: "38px" }}
                      onClick={(e) => {
                        formik.handleSubmit();
                      }}
                      text={"Guardar"}
                      loadingText={"Guardando..."}
                      isLoading={isLoading}
                    />
                  }
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default ConfigForaneo;
